import { z } from 'zod';
import { InteractionProvider } from '../index.js';
import { InteractionEventType } from './index.js';
export const VonageSMSEventBronzeDataSchema = z.object({
    'api-key': z.string(), // "557201a0"
    'client-ref': z.string(), // "5d85e77f-6e79-4752-92eb-f124751038f7"
    'err-code': z.string(), // "0"
    'message-timestamp': z.string(), // "2025-06-01 03:05:11"
    messageId: z.string(), // "02c9bbcc-e894-4b59-8d0b-ca7e20630791"
    msisdn: z.string(), // "4529731796"
    'network-code': z.string().optional(), // "23801"
    price: z.string().optional(), // "0.05082000"
    scts: z.string().optional(), // "2506010505"
    status: z.string(), // "delivered"
    to: z.string(), // "Demo"
});
export const VonageSMSEventSchema = z.object({
    provider: z.literal(InteractionProvider.VonageSMS),
    bronzeData: VonageSMSEventBronzeDataSchema,
});
export const mapVonageSMSEvent = (bronzeEvent) => {
    if (bronzeEvent['err-code'] === '0') {
        return {
            provider: InteractionProvider.VonageSMS,
            type: InteractionEventType.Delivered,
            data: {},
            bronzeData: bronzeEvent,
        };
    }
    else {
        return {
            provider: InteractionProvider.VonageSMS,
            type: InteractionEventType.Failed,
            data: {
                reason: vonageSMSErrorCodes[bronzeEvent['err-code']] || 'Unknown error',
            },
            bronzeData: bronzeEvent,
        };
    }
};
const vonageSMSErrorCodes = {
    '0': 'Delivered	Message was delivered successfully.',
    '1': 'Unknown	Message was not delivered and no cause could be determined.',
    '2': 'Absent Subscriber - Temporary	Message was not delivered because handset was temporarily unavailable. Retry.',
    '3': 'Absent Subscriber - Permanent	Number is no longer active and should be removed from your database.',
    '4': 'Call Barred by User	Permanent error. Number should be removed from your database and the user must contact their network operator to remove the bar.',
    '5': 'Portability Error	Issue relating to portability of the number. Contact the network operator to resolve it.',
    '6': "Anti-Spam Rejection	Message blocked by carrier's anti-spam filter.",
    '7': 'Handset Busy	Handset not available at the time message was sent. Retry.',
    '8': 'Network Error	Message failed due to network error. Retry.',
    '9': 'Illegal Number	User has requested not to receive messages from a specific service.',
    '10': 'Illegal Message	Error in message parameter, e.g., wrong encoding flag.',
    '11': 'Unroutable	Vonage cannot find a suitable route to deliver the message.',
    '12': "Destination Unreachable	Route to number cannot be found. Confirm the recipient's number.",
    '13': 'Subscriber Age Restriction	Target cannot receive message due to their age.',
    '14': 'Number Blocked by Carrier	Recipient should ask their carrier to enable SMS on their plan.',
    '15': 'Insufficient Funds	Vonage customer does not have enough credit to send the messages.',
    '16': 'Gateway Quota Exceeded	Message delivery failed because the allowed number of requests per period was exceeded. NB: This error is shown for accounts registered in the US and France only. ',
    '17': '	Message Blocked by Provider	The messaging provider has chosen to block this message. This may be due to content or restrictions imposed by the provider. ',
    '50': 'Entity Filter	Message failed due to entity-id being incorrect or not provided. See more information on country specific regulations.',
    '51': 'Header Filter	Message failed because the header ID (from phone number) was incorrect or missing. See more information on country specific regulations.',
    '52': 'Content Filter	Message failed due to content-id being incorrect or not provided. See more information on country specific regulations.',
    '53': 'Consent Filter	Message failed due to consent not being authorized. See more information on country specific regulations.',
    '54': 'Regulation Error	Unexpected regulation error.',
    '99': 'General Error	Typically refers to an error in the route.',
};
//# sourceMappingURL=vonage-sms.js.map